<template>
  <b-container>
    <b-row class="mt-3 justify-content-center">
      <b-col cols="12" lg="10" class="p-5">
        <b-img
          :src="require('@/assets/img/fullwidth/page-not-found.png')"
          fluid
        />
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col cols="12" lg="8" class="text-center" style="font-size: 22px;">
        Rescue me! Take me <router-link tag="a" :to="{ name: 'Home' }">Home</router-link>
      </b-col>
    </b-row>

    <b-row class="mt-5" />
  </b-container>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue